import dataScientistPython from "../../assets/certs/2020_data_scientist_python.pdf"
import toefl from "../../assets/certs/2020_toefl.pdf"
import toeic from "../../assets/certs/2020_toeic.pdf"
import cfa from "../../assets/certs/2021_cfa_i.pdf"
import algoExpert from "../../assets/certs/2022_algoexpert.pdf"
import cleanCode from "../../assets/certs/2022_clean_code.pdf"
import completeWebDev from "../../assets/certs/2022_complete_web_dev_ztm.pdf"
import databaseEngineering from "../../assets/certs/2022_database_engineering.pdf"
import designPatterns from "../../assets/certs/2022_design_patterns.pdf"
import devopsTerraform from "../../assets/certs/2022_devops_terraform.pdf"
import dockerKubernetes from "../../assets/certs/2022_docker_kubernetes.pdf"
import featureEngineering from "../../assets/certs/2022_feature_engineering.pdf"
import featureSelection from "../../assets/certs/2022_feature_selection.pdf"
import functionalProgramming from "../../assets/certs/2022_functional_programming.pdf"
import gitGithub from "../../assets/certs/2022_git_github.pdf"
import googleCloudDigitalLeader from "../../assets/certs/2022_google_cloud_digital_leader_training.pdf"
import hyperparameterOptimization from "../../assets/certs/2022_hyperparameter_optimization.pdf"
import mldsBootcamp from "../../assets/certs/2022_mlds_bootcamp.pdf"
import mlExpert from "../../assets/certs/2022_mlexpert.pdf"
import mlops from "../../assets/certs/2022_mlops.pdf"
import programmingExpert from "../../assets/certs/2022_programming_expert.pdf"
import pyspark from "../../assets/certs/2022_pyspark.pdf"
import pythonOOP from "../../assets/certs/2022_python_oop.pdf"
import sqlDatabases from "../../assets/certs/2022_sql_and_databases.pdf"
import systemDesign from "../../assets/certs/2022_system_design.pdf"
import cs50x from "../../assets/certs/2023_cs50x.pdf"
import frontendExpert from "../../assets/certs/2023_frontend_expert.pdf"
import machineLearningSpecialization from "../../assets/certs/2023_machine_learning_specialization.pdf"
import gcloudDataEngineer from "../../assets/certs/2024_gcloud_data_engineer.pdf"
import gcpCloudEngineer from "../../assets/certs/2024_gcp_cloud_engineer.pdf"
import go from "../../assets/certs/2024_go.pdf"
import langchain from "../../assets/certs/2024_langchain.pdf"
import mlDeployment from "../../assets/certs/2024_ml_deployment.pdf"
import scala from "../../assets/certs/2024_scala.pdf"
import linux from "../../assets/certs/2025_linux.pdf"
import react from "../../assets/certs/2025_react.pdf"
import rust from "../../assets/certs/2025_rust.pdf"
import { useTheme } from "../../theme/useTheme"
import { ContentSection } from "../layout/ContentSection"
import { Deemphasize } from "../ui/CustomTypography"
import { Link } from "../ui/Link"
import { Typography } from "@mui/material"

export const AwardsAndCertificates = () => {
    const { visibility } = useTheme()
    // tier-1 (8 core, every edition) lists first in priority order; tier-2 is
    // role-relevant proof; tier-3 is the padding/archive reserve (web + full
    // PDF only). No entry is ever deleted — only tiers move.
    const certificates = [
        <span key="gcloud-data-engineer" className="visibility-tier-1">
            <Link href={gcloudDataEngineer}>Google Cloud Certified Data Engineer</Link>
        </span>,
        <span key="gcp-cloud-engineer" className="visibility-tier-1">
            <Link href={gcpCloudEngineer}>GCP Cloud Engineer</Link>
        </span>,
        <span key="cs50x" className="visibility-tier-1">
            <Link href={cs50x}>CS50x</Link> by Harvard University
        </span>,
        <span key="ml-specialization" className="visibility-tier-1">
            <Link href={machineLearningSpecialization}>Machine Learning Specialization</Link> by Stanford
            University
        </span>,
        <span key="mlops" className="visibility-tier-1">
            <Link href={mlops}>MLOps Specialization</Link> by Deeplearning.ai
        </span>,
        <span key="langchain" className="visibility-tier-1">
            <Link href={langchain}>LangChain</Link>
        </span>,
        <span key="cfa" className="visibility-tier-1">
            <Link href={cfa}>Passed CFA Level I</Link>
        </span>,
        <span key="toeic" className="visibility-tier-1">
            <Link href={toeic}>TOEIC</Link> (925/990)
        </span>,
        <span key="pyspark" className="visibility-tier-2">
            <Link href={pyspark}>PySpark</Link>
        </span>,
        <span key="rust" className="visibility-tier-2">
            <Link href={rust}>Rust</Link>
        </span>,
        <span key="go" className="visibility-tier-2">
            {/* bare "Go" is on Lighthouse's generic-link-text blocklist ("go")
                — the sr-only suffix names the destination; innerText (which
                the audit reads) includes clipped text, unlike display:none */}
            <Link href={go}>
                Go
                <span
                    style={{
                        position: "absolute",
                        width: "1px",
                        height: "1px",
                        overflow: "hidden",
                        clip: "rect(0 0 0 0)",
                        whiteSpace: "nowrap",
                    }}
                >
                    {" "}
                    programming language certificate
                </span>
            </Link>
        </span>,
        <span key="linux-bash" className="visibility-tier-2">
            <Link href={linux}>Linux and Bash Scripting</Link>
        </span>,
        <span key="sql-databases" className="visibility-tier-2">
            <Link href={sqlDatabases}>SQL & Databases</Link>
        </span>,
        <span key="db-engineering" className="visibility-tier-2">
            <Link href={databaseEngineering}>Fundamentals of Database Engineering</Link>
        </span>,
        <span key="devops-terraform" className="visibility-tier-2">
            <Link href={devopsTerraform}>DevOps: Infrastructure as Code With Terraform</Link>
        </span>,
        <span key="docker-kubernetes" className="visibility-tier-2">
            <Link href={dockerKubernetes}>Docker & Kubernetes</Link>
        </span>,
        <span key="system-design" className="visibility-tier-2">
            <Link href={systemDesign}>System Design</Link>
        </span>,
        <span key="deploy-ml" className="visibility-tier-2">
            <Link href={mlDeployment}>Deployment of Machine Learning Models</Link>
        </span>,
        <span key="scala" className="visibility-tier-3">
            <Link href={scala}>Scala</Link>
        </span>,
        <span key="clean-code" className="visibility-tier-3">
            <Link href={cleanCode}>Clean Code</Link>
        </span>,
        <span key="design-patterns" className="visibility-tier-3">
            <Link href={designPatterns}>Design Patterns</Link>
        </span>,
        <span key="functional-programming" className="visibility-tier-3">
            <Link href={functionalProgramming}>Functional Programming</Link>
        </span>,
        <span key="programming-expert" className="visibility-tier-3">
            <Link href={programmingExpert}>Python & Golang</Link>
        </span>,
        <span key="python-oop" className="visibility-tier-3">
            <Link href={pythonOOP}>Python OOP</Link>
        </span>,
        <span key="git-github" className="visibility-tier-3">
            <Link href={gitGithub}>Git & GitHub</Link>
        </span>,
        <span key="ml-expert" className="visibility-tier-3">
            <Link href={mlExpert}>Machine Learning Expert</Link>
        </span>,
        <span key="algo-expert" className="visibility-tier-3">
            <Link href={algoExpert}>Algorithm & Data Structure</Link>
        </span>,
        <span key="toefl" className="visibility-tier-2">
            <Link href={toefl}>TOEFL ITP</Link> (560/677)
        </span>,
        <span key="gcp-digital-leader" className="visibility-tier-3">
            <Link href={googleCloudDigitalLeader}>Google Cloud Digital Leader Training</Link>
        </span>,
        <span key="mlds-bootcamp" className="visibility-tier-3">
            <Link href={mldsBootcamp}>Machine Learning & Data Science Bootcamp</Link>
        </span>,
        <span key="feature-engineering" className="visibility-tier-3">
            <Link href={featureEngineering}>Feature Engineering</Link>
        </span>,
        <span key="feature-selection" className="visibility-tier-3">
            <Link href={featureSelection}>Feature Selection</Link>
        </span>,
        <span key="hyperparameter-optimization" className="visibility-tier-3">
            <Link href={hyperparameterOptimization}>Hyperparameter Optimization</Link>
        </span>,
        <span key="complete-web-dev" className="visibility-tier-3">
            <Link href={completeWebDev}>The Complete Web Developer</Link>
        </span>,
        <span key="frontend-expert" className="visibility-tier-3">
            <Link href={frontendExpert}>Frontend Expert</Link>
        </span>,
        <span key="react" className="visibility-tier-3">
            <Link href={react}>React</Link>
        </span>,
        <span key="data-scientist-python" className="visibility-tier-3">
            <Link href={dataScientistPython}>Data Scientist with Python Track</Link> by Data Camp
        </span>,
    ]

    const filterByTier = (cert: React.ReactElement) => {
        const props = cert.props as { className: string }
        let tier = 3
        if (props.className.includes("visibility-tier-1")) {
            tier = 1
        } else if (props.className.includes("visibility-tier-2")) {
            tier = 2
        }
        return tier <= visibility.visibilityTier
    }

    const filteredCertificates = certificates.filter(filterByTier).map((cert) => cert.props.children)

    const renderCertificates = (certificates: React.ReactNode[]) =>
        certificates.map((cert, index) => (
            <span key={index}>
                {cert}
                {index < certificates.length - 1 && <Deemphasize>{" • "}</Deemphasize>}
            </span>
        ))

    return (
        <ContentSection title="Awards and Certificates">
            <Typography variant="body1">{renderCertificates(filteredCertificates)}</Typography>
        </ContentSection>
    )
}
